var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTrashAll(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.65902 0.0174906C6.5834 0.0253859 6.43746 0.0506999 6.33472 0.0737347C5.18897 0.330716 4.28595 1.23066 4.02096 2.37962L3.98435 2.53834H0V3.56392H0.732558C1.21553 3.56392 1.46512 3.56954 1.46512 3.58038C1.46512 3.60434 2.71639 13.6226 2.72723 13.6854L2.73637 13.7383H7.08592L7.07733 12.7209L5.79128 12.7168C4.35144 12.714 3.63023 12.7072 3.63023 12.6962C3.63023 12.6748 2.51015 3.70483 2.4975 3.62497L2.48783 3.56392H6.99857C9.47946 3.56392 11.509 3.5694 11.5086 3.57613C11.5081 3.58285 11.3992 4.45276 11.2665 5.50927C11.1338 6.56578 10.9375 8.45833 10.9375 8.45833L11.9596 8.45833C12.0537 7.67897 12.5355 3.59354 12.5351 3.57613C12.535 3.5694 12.8645 3.56392 13.2674 3.56392H14V2.53834H10.0156L9.97904 2.37962C9.84776 1.81045 9.5711 1.31456 9.14977 0.893223C8.49128 0.234719 7.59533 -0.0802978 6.65902 0.0174906ZM6.66525 1.04976C6.04339 1.15431 5.49034 1.55687 5.20224 2.11471C5.1592 2.19804 5.1032 2.3256 5.07778 2.39821L5.0316 2.5302L6.0158 2.5344C6.55711 2.53671 7.44256 2.53671 7.98348 2.5344L8.96697 2.5302L8.92072 2.39669C8.67463 1.68655 8.05972 1.16867 7.32024 1.04874C7.13914 1.01935 6.84335 1.01983 6.66525 1.04976Z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60001 5.5988L5.93915 10.6946L4.92171 10.686L4.57433 5.5988H5.60001Z",
    fill: "#000000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.20969 8.45833H9.23042L9.42569 5.5988H8.40001L8.20969 8.45833Z",
    fill: "#000000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09375 10.3542V9.33333H13.125V10.3542H8.09375Z",
    fill: "#000000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09375 12.1042H13.125V11.0833H8.09375V12.1042Z",
    fill: "#000000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09375 13.7375H13.125V12.7167H8.09375V13.7375Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrashAll);
export default __webpack_public_path__ + "static/media/icon--trash-all.d730988021a1af08316bbaa86a277e4a.svg";
export { ForwardRef as ReactComponent };